import ContentfulInternationalSizeConversionGuide from '@src/quince-site-common/src/domains/contentful/contentful-international-size-conversion-guide'
import ContentfulProductMeasuringGuide from '@src/quince-site-common/src/domains/contentful/ContentfulMeasuringGuide'
import { ContentfulSizeChart } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

enum ProductSizeGuideDesignVariant {
  DESIGN_1,
  DESIGN_2,
}

interface ProductSizeGuide {
  sizeChart: ContentfulSizeChart
  measuringGuide?: ContentfulProductMeasuringGuide
  internationalSizeChart: ContentfulInternationalSizeConversionGuide | undefined
}

interface PDPProductSizeGuide {
  tabName: string
  productSizeGuides: ProductSizeGuide[]
}

export { ProductSizeGuideDesignVariant, ProductSizeGuide, PDPProductSizeGuide }
